import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'flinkit-outdoor';
  isShowcaseMode = false;
  isVirtualMode = false;
  selectedGameMode: 'outdoor' | 'indoor' | 'event-hall' = 'outdoor';
  virtualText = '';
  virtualLogos = [
    './assets/images/clients/coca.png',
    './assets/images/clients/microsoft.jpg',
    './assets/images/clients/uber.svg',
    './assets/images/clients/morgan_stanley.png'
  ];

  get leftPanelCopy(): { title: string; tagline: string; description: string } {
    const copyMap = {
      outdoor: {
        title: 'Flinkit Outdoor',
        tagline: 'Turn any city into a team challenge!',
        description:
          'Create and manage super fun, location-based games and events that boost engagement, increase revenue, and reduce operational effort — all in the browser.'
      },
      indoor: {
        title: 'Flinkit Indoor',
        tagline: 'Turn any venue into a team challenge!',
        description:
          'Run indoor, room-to-room experiences for museums, exhibitions, and team events — with guided challenges that keep groups moving and engaged.'
      },
      'event-hall': {
        title: 'Flinkit Event Hall',
        tagline: 'Turn your event hall into a live team challenge!',
        description:
          'Power conferences and event halls with interactive challenges that drive booth traffic, spark conversations, and make engagement measurable.'
      }
    } as const;

    return copyMap[this.selectedGameMode] ?? copyMap.outdoor;
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    console.log('V 1.0')
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0);
        this.checkShowcaseAndVirtualMode();
    });
    this.checkShowcaseAndVirtualMode();
  }

  checkShowcaseAndVirtualMode() {
    // Check query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const virtual = urlParams.get('virtual');
    const type = urlParams.get('type');
    const tid = urlParams.get('tid'); // tourId
    
    // Check for showcase in both query params and matrix params (matrix params appear before ?)
    // Matrix params format: /path;param=value?query=value
    let showcase = urlParams.get('showcase');
    if (!showcase) {
      // Check matrix params by parsing the full URL path
      const fullUrl = window.location.href;
      const pathPart = fullUrl.split('?')[0]; // Get part before query string
      const matrixMatch = pathPart.match(/[;]showcase=([^;?]+)/);
      if (matrixMatch) {
        showcase = matrixMatch[1];
      }
    }
    
    this.isShowcaseMode = showcase === 'true';
    // Virtual mode is active when showcase=true AND virtual parameter exists (virtual=true OR just virtual in URL)
    // URLSearchParams.get() returns null if parameter doesn't exist, '' if empty, or the value if set
    this.isVirtualMode = this.isShowcaseMode && virtual !== null;
    
    // Detect game mode from tid (tourId) parameter first, then fall back to type parameter
    // tourId mapping based on gamepass-redirect: 
    // type=1 → 695bf6db9933ee260e525657 (Event Hall)
    // type=2 → 695bf6899933ee260e525656 (Indoor)
    // type=3 → 695be0129933ee260e525651 (Outdoor)
    if (tid) {
      const tidModeMap: Record<string, 'outdoor' | 'indoor' | 'event-hall'> = {
        '695bf6db9933ee260e525657': 'event-hall',  // type=1
        '695bf6899933ee260e525656': 'indoor',      // type=2
        '695be0129933ee260e525651': 'outdoor'      // type=3
      };
      if (tidModeMap[tid]) {
        this.selectedGameMode = tidModeMap[tid];
        return; // Exit early if tid is found
      }
    }
    
    // Fall back to type parameter if tid not found: type=1=event-hall, type=2=indoor, type=3=outdoor
    if (type) {
      const typeModeMap: Record<string, 'outdoor' | 'indoor' | 'event-hall'> = {
        '1': 'event-hall',
        '2': 'indoor',
        '3': 'outdoor'
      };
      if (typeModeMap[type]) {
        this.selectedGameMode = typeModeMap[type];
      }
    }
  }

  setGameMode(mode: 'outdoor' | 'indoor' | 'event-hall') {
    this.selectedGameMode = mode;
    
    // Map mode to type: outdoor=3, indoor=2, event-hall=1
    const typeMap = {
      'outdoor': '3',
      'indoor': '2',
      'event-hall': '1'
    };
    
    const type = typeMap[mode];
    if (type) {
      // Detect locale from URL or default to 'en'
      let locale = 'en';
      const href = window.location.href;
      if (href.indexOf('/hu/') !== -1) {
        locale = 'hu';
      } else if (href.indexOf('/de/') !== -1) {
        locale = 'de';
      } else if (href.indexOf('/fr/') !== -1) {
        locale = 'fr';
      } else if (href.indexOf('/es/') !== -1) {
        locale = 'es';
      } else if (href.indexOf('/nl/') !== -1) {
        locale = 'nl';
      }
      
      // Redirect to gamepass-redirect with the appropriate type
      this.router.navigate(['/gamepass-redirect'], {
        queryParams: {
          type: type,
          locale: locale
        }
      });
    }
  }
}

/* translate(){
  let  translations = {
    "Hall of fame":{
        'en':"Hall of fame",
        'de':"Ruhmeshalle",
        'hu':"Eredmények",
        'nl':"Eregalerij",
        'fr':"Palmarès",
    },
    "Maximum number of players reached":{
        'en':"Maximum number of players reached",
        'de':"Maximale Spieleranzahl erreicht",
        'hu':"A maximális játékos szám elérve",
        'nl':"Maximaal aantal spelers bereikt",
        'fr':"Nombre de joueurs maximum atteint",
    },
    "Image successfully uploaded":{
        'en':"Image successfully uploaded",
        'de':'Bild erfolgreich hochgeladen',
        'hu':'Kép sikeresen feltöltve',
        'nl':'Afbeelding succesvol geüpload',
        'fr':"Image téléchargée avec succès",
    },
    "You can throw a bomb on a random player.":{
        'en':"You can throw a bomb on a random player.",
        'de':'Sie können eine Bombe per Zufallsgenerator werfen.',
        'hu':'Bombát dobhatsz egy véletlenszerűen kiválasztott játékosra. A bomba hatása, hogy a következő helyes válasz esetén a játékos csupán fele annyi pontot szerez.',
        'nl':'Je kunt een bom op een willekeurige speler gooien.',
        'fr':"Vous pouvez lancer une bombe sur un joueur au hasard.",
    },
    "You just activated the bomb perk.":{
        'en':"You just activated the bomb perk.",
        'de':'Du hast gerade den Effekt "Bombe" aktiviert.',
        'hu':'Aktiváltad a bombát!',
        'nl':'Je hebt zojuist het bomvoordeel geactiveerd.'
    },
    "Bomb perk active. Half points at next question.":{
        'en':"You just activated the bomb perk.",
        'de':'Bombenvorteil aktiv. Halbe Punkte bei der nächsten Frage.',
        'hu':'Bomba aktív! Fél pont a következő kérdésnél.',
        'nl':'Bomvoordeel actief. Halve punten bij volgende vraag.'
    },

    
    "No other players to use this perk on.":{
        'en':"No other players to use this perk on.",
        'de':'Keine anderen Spieler, bei denen dieser Effekt verwendet werden kann.',
        'hu':'Nincs más játékos a játékban, akin alkalmazni tudnád ezt a funkciót.',
        'nl':'Geen andere spelers om dit voordeel op te gebruiken.'
    },
    "Freeze":{
        'en':"Freeze",
        'de':'Einfrieren',
        'hu':'Fagyasztás',
        'nl':'Bevriezen'
    },
    "Free":{
        'en':"Free",
        'de':'Kostenlos',
        'hu':'Ingyenes',
        'nl':'Vrij'
    },
    "Bomb":{
        'en':"Bomb",
        'de':'Bomb',
        'hu':'Bomba',
        'nl':'Bomb'
    },
    "Blank map":{
        'en':"Blank map",
        'de':'Leere Karte',
        'hu':'Vaktérkép',
        'nl':'Lege kaart'
    },
    "Photo gallery":{
        'en':"Take photos",
        'de':'Fotogallerie',
        'hu':'Fotó galéria',
        'nl':'Fotogallerij'
    },
    "freeze":{
        'en':"Freeze",
        'de':'Einfrieren',
        'hu':'Fagyasztás',
        'nl':'Bevriezen'
    },
    "bomb":{
        'en':"Bomb",
        'de':'Bomb',
        'hu':'Bomba',
        'nl':'Bomb'
    },
    "photo":{
        'en':"Photo gallery",
        'de':'Fotogallerie',
        'hu':'Fotó galéria',
        'nl':'Fotogallerij'
    },
    "map_tap":{
        'en':'Map tap',
        'de':'Kartenberührung',
        'hu':'Térkép érintés',
        'nl':'Kaart tik'
    },
    
    "Freeze perk will freeze all other players for 30 seconds.":{
        'en':"Freeze perk will freeze all other players for 30 seconds.",
        'de':'Freeze Perk friert alle anderen Spieler für 30 Sekunden ein.',
        'hu':'A fagyasztás funkció 30 másodpercig fagyasztja a többi játékost.',
        'nl':'Freeze perk bevriest alle andere spelers gedurende 30 seconden.'
    },
    'You can take photos during the game.': {
        'en':'You can take photos during the game.',
        'de':'Sie können während des Spiels Fotos machen.',
        'hu':'Fotókat tudsz készíteni a játék során.',
        'nl':"Tijdens het spel kun je foto's maken."
    },
    'You just activated the photo perk.': {
        'en':'You just activated the photo perk.',
        'de':'Sie haben gerade den Foto Effekt eingesetzt',
        'hu':'Aktiváltad a fotó funkciót!',
        'nl':'Je hebt zojuist het fotovoordeel geactiveerd.'
    },
    'Blank map perk is active for 30 seconds.': {
        'en':'Blank map perk is active for 30 seconds.',
        'de':'Der Spezialeffekt „Leere Karte“ ist 30 Sekunden lang aktiv.',
        'hu':'Vaktérkép aktív 30 másoedpercig.',
        'nl':'Blanco kaartvoordeel is 30 seconden actief.'
    },
    'It will change the map style to a blank map for other players for 30 seconds.': {
        'en':'It will change the map style to a blank map for other players for 30 seconds.',
        'de':'Der Kartenstil wird für andere Spieler 30 Sekunden lang in eine leere Karte geändert.',
        'hu':'A térkép stílusát 30 másodpercig vaktérképpé változtatja.',
        'nl':'Het verandert de kaartstijl gedurende 30 seconden in een lege kaart voor andere spelers.'
    },
    'PIN to join the game: ': {
        'en':'PIN to join the game: ',
        'de':'PIN, um dem Spiel beizutreten:  ',
        'hu':'Játék PIN',
        'nl':'PIN om mee te doen aan het spel'
    },
    
    'Position updated!': {
        'en':'Position updated!',
        'de':'Position aktualisiert.',
        'hu':'Pozíció frissítve',
        'nl':'Positie bijgewerkt!'
    },
    'What is the goal of the game?': {
        'en':'What is the goal of the game?!',
        'de':'Was ist das Ziel des Spiels?',
        'hu':'Mi a játék célja?',
        'nl':'Wat is het doel van het spel?'
    },
    'To collect all the story points': {
        'en':'To collect all the story points',
        'de':'Erreiche alle Wegpunkte und gewinne Punkte.',
        'hu':'Valamennyi kérdés megválaszolása',
        'nl': 'Om alle verhaalpunten te verzamelen'
    },
    'To wait until the time is up': {
        'en':'To wait until the time is up',
        'de':'Warte bis die Zeit um ist.',
        'hu':'Megvárni ameddig letelik az idő',
        'nl':'Om te wachten tot de tijd om is'
    },
    'To stay outside the battle circle': {
        'en':'To stay outside the battle circle',
        'de':'Innerhalb des Kreises (der Battle Arena) bleiben. ',
        'hu':'Kimaradni a harci körből',
        'nl':'Om buiten de strijdcirkel te blijven'
    },
    "Don't forget to use the 'Refresh my position' button regularly to refresh your current location in the game.": {
        'en':"Don't forget to use the 'Refresh my position' button regularly to refresh your current location in the game.",
        'de':'Schaltfläche "Position aktualisieren" regelmässig klicken, um Standort im Spiel zu aktualisieren.',
        'hu':"Ne nefejtsd el haszánli a 'Pozícióm frissítése' gombot, mivel ezzel frissíted helyzetedet a térképen.",
        'nl':"Vergeet niet regelmatig de knop 'Vernieuw mijn positie' te gebruiken om je huidige locatie in het spel te vernieuwen."
    },
    "Hurry up, only ": {
        'en':"Hurry up, only ",
        'de':"Beeilung, nur ",
        'hu':'Siess, már csak ',
        'nl':'Schiet op, er resteren slechts'
    },
    " minutes left!": {
        'en':" minutes left!",
        'de':" Minuten übrig!",
        'hu':' perc maradt! ',
        'nl':' minuten!'
    },
    "Got it": {
        'en':"Got it",
        'de':"Verstanden!",
        'hu':'Értettem ',
        'nl': 'Ik snap het'
    },
    "Backpack item": {
        'en':"Backpack item",
        'de':"Spezialobjekt für Rucksack",
        'hu':'Hátizsták tárgy ',
        'nl':'Rugzakartikel'
    },
    "This item may help you to solve the final riddle.": {
        'en':"This item may help you to solve the final riddle.",
        'de':"Dieses Objekt kann helfen, das letzte Rätsel zu lösen.",
        'hu':'A tárgy segítségedre lehet megoldani a végső rejtélyt ',
        'nl': 'Dit item kan je helpen om het laatste raadsel op te lossen.'
    },
    "Back": {
        'en':"Back",
        'de':"Zurück",
        'hu':'Vissza',
        'nl':'Annuleren'
    },
    "Next": {
        'en':"Next",
        'de':"Nächste",
        'hu':'Tovább',
        'nl':'De volgende'
    },
    "Congrats! You've activated the safehouse! Now find it on the map and reach it before it's too late!": {
        'en':"Congrats! You've activated the safehouse! Now find it on the map and reach it before it's too late!",
        'de':"Herzlichen Glückwunsch! Das Safehouse wurde aktiviert. Lokalisiere es auf der Karte und erreiche es, bevor es zu spät ist.",
        'hu':'Gratulálunk! Aktiváltad a "safe house"-t. Most keresd meg a térképen és érd el a lehető leggyorsabban!',
        'nl':'Proficiat! Je hebt het safehouse geactiveerd! Vind het nu op de kaart en bereik het voordat het te laat is!'
    },
    ' is a fellow player in the musesum who scored ': {
        'en':' is a fellow player in the musesum who scored ',
        'de':' ist MitspielerIn im Museum und hat gepunktet ',
        'hu':' egy másik játékos a múzeumban, aki elért ',
        'nl':' is een medespeler. Die scoorde '
    },
    " points so far.": {
        'en':" points so far.",
        'de':" Punkte bisher.",
        'hu':' pontot eddig.',
        'nl': ' punten tot nu toe.'
    },
    " The player is still in the museum!": {
        'en':" The player is still in the museum!",
        'de':" Der Spieler ist immer noch im Museum!",
        'hu':' A játékos jelenleg is aktív.',
        'nl': 'De speler is nog steeds aan het spelen!'
    },
    "You don't have enough points to use this perk.": {
        'en':"You don't have enough points to use this perk.",
        'de':"Zu wenig Punkte, um Spezialeffekt zu nutzen.",
        'hu':'Nincs elég pontod, hogy használd!',
        'nl': 'Je hebt niet genoeg punten om dit voordeel te gebruiken.'
    },
    "Use perk": {
        'en':"Use perk",
        'de':"Spezialeffekt einsetzen",
        'hu':'Használom',
        'nl': 'Gebruik extra'
    },
    "Double perk is active. You will receive doupled points at the next question if your answer is correct.": {
        'en':"Double perk is active. You will receive doupled points at the next question if your answer is correct.",
        'de':'Doppler-Effekt ist aktiv. Bei richtiger Beantwortung der nächsten Frage gibt es doppelte Punktzahl.',
        'hu':'A duplázás aktív. Dupla pontot kapsz, ha helyesen válaszolsz!',
        'nl': 'Dubbel voordeel is actief. Je krijgt dubbele punten bij de volgende vraag als je antwoord juist is.'
    },
   
   

    "Freeze perk is active. You frozed all other players for 30 seconds.": {
        'en':"Freeze perk is active. You frozed all other players for 30 seconds.",
        'de':'Freeze Effekt ist aktiv. Die anderen Spieler wurden für 30 Sekunden eingefroren.',
        'hu':'Fagyasztás aktív. Lefagyasztottad az ellenfeleidet 30 másodpercre.',
        'nl':'Freeze-voordeel is actief. Je bevriest alle andere spelers gedurende 30 seconden.'
    },
    'Do you really want to end the game?': {
        'en':'Do you really want to end the game?',
        'de':'Soll das Spiel wirklich beendet werden?',
        'hu':'Biztosan szeretnéd befejezni a játékot?',
        'nl':'Wil je het spel echt beëindigen?'
    },
    "You cannot rejoin in the game if you hit 'End Game'": {
        'en':"You cannot rejoin in the game if you hit 'End Game'",
        'de':'Das Spiel kann nicht wieder betreten werden, wenn "Spiel beenden" geklickt wird.',
        'hu':"A játék véglegesen befejeződik a 'Játék befejezése' gombra kattintva",
        'nl':"Als je het spel beëindigt, stopt het voor alle spelers. Je kunt dit niet ongedaan maken."
    },
    "End Game": {
        'en':"End Game",
        'de':"Spiel beenden",
        'hu':'Játék befejezése',
        'nl':'Spel beëindigen'
    },
    'This QR code has been activated already': {
        'en':'This QR code has been activated already',
        'de':'Dieser QR-Code wurde bereits aktiviert',
        'hu':'Ez a QR kód már korábban használva volt',
        'nl':'Deze QR-code is al geactiveerd'
    },
    'Do you really want to launch the game?': {
        'en':'Do you really want to launch the game?',
        'de':'Spiel jetzt starten?',
        'hu':'Biztosan szeretnéd elindítani a játkot?',
        'nl':'Wil je het spel echt starten?'
    },
    'The game will start for every other players by clicking "Start game"': {
        'en':'The game will start for every other players by clicking "Start game"',
        'de':'Das Spiel startet für alle SpielerInnen nach Klick auf "Spiel starten"',
        'hu':'A játék a "Játék indítása" gomb lenyomásával indul',
        'nl':'Zodra je klikt op “Spel starten”, zal het spel voor iedereen van start gaan.'
    },
    'PIN error': {
        'en':'PIN error',
        'de':'PIN-Fehler',
        'hu':'PIN hiba',
        'nl': 'PIN-fout'
    },
    'This PIN has expired': {
        'en':'This PIN has expired',
        'de':'Diese PIN ist abgelaufen',
        'hu':'A PIN lejárt',
        'nl': 'Deze pincode is verlopen'

    },
    'Wrong PIN': {
        'en':'Wrong PIN',
        'de':'Falsche PIN',
        'hu':'Hibás PIN',
        'nl':'Verkeerde pincode'
    },
    'There is no game with this PIN': {
        'en':'There is no game with this PIN',
        'de':'Es gibt ken Spiel zu dieser PIN',
        'hu':'Nem találtunk játékot ezzel a PIN-el',
        'nl': 'Er is geen spel met deze pincode'
    },
    'Cannot access location': {
        'en':'Cannot access location',
        'de':'Kann Standort nicht abrufen',
        'hu':'Lokáció letiltva',
        'nl':'Geen toegang tot locatie'
    },
    'You need to grant access to the browser to start the game.': {
        'en':'You need to grant access to the browser to start the game.',
        'de':'Sie müssen den Zugriff auf den Browser gewähren, um das Spiel zu starten.',
        'hu':'A lokáció engedélyezése szükséges a játékhoz.',
        'nl':'Je moet toegang verlenen tot de browser om het spel te starten.'
    },
    "You are standing outside the battle circle. You've lost ": {
        'en':"You are standing outside the battle circle. You've lost ",
        'de':'Außerhalb des Kreises! Strafscore: ',
        'hu':'A harci körön kívül állsz. Vesztettél: ',
        'nl': 'Je staat buiten de gevechtscirkel. Je hebt verloren'
    },
    ' points!': {
        'en':' points!',
        'de':' Punkte',
        'hu':' pont.',
        'nl':' punten!'
    },
    'Well, there are no markers nearby.': {
        'en':'Well, there are no markers nearby.',
        'de':'Keine Wegpunkte in der Nähe.',
        'hu':'Nincs kérdés a közeledben',
        'nl': 'Nou, er zijn geen markeringen in de buurt.'
    },
    'Correct answer': {
        'en':'Correct answer',
        'de':'Richtige Antwort',
        'hu':'Helyes válasz',
        'nl': 'Goed antwoord'
    },
    'Correct answer! You have earned ': {
        'en':'Correct answer! You have earned ',
        'de':'Richtige Antwort! Du erhältst ',
        'hu':'Helyes válasz! Jutalmad: ',
        'nl': 'Goed antwoord! Je hebt verdiend: '
    },
    'The correct answer would be: ': {
        'en':'The correct answer would be: ',
        'de':'Die richtige Antwort wäre: ',
        'hu':'A helyes válasz: ',
        'nl': 'Het juiste antwoord was: '
    },
    'The time is up': {
        'en':'The time is up',
        'de':'Die Zeit ist aufgelaufen.',
        'hu':'Lejárt az idő',
        'nl':'De tijd is op'
    },
    'A new item has been added to your backpack!': {
        'en':'A new item has been added to your backpack!',
        'de':'Ein neues Objekt wurde in den Rucksack gelegt.',
        'hu':'Új elem került a hátizsákodba',
        'nl':'Er is een nieuw item aan je rugzak toegevoegd!'
    },
    'Incorrect answer': {
        'en':'Incorrect answer',
        'de':'Falsche Antwort',
        'hu':'Helytelen válasz',
        'nl':'Fout antwoord'
    },
    'Try again': {
        'en':'Try again',
        'de':'Nichmals versuchen',
        'hu':'Próbáld újra',
        'nl':'Probeer het opnieuw'
    },
    'Start game': {
        'en':'Start game',
        'de':'Spiel starten',
        'hu':'Játék indítása',
        'nl':'Spel starten'
    },
    'Getting location data takes more time than usual. Please wait for the map to initialize': {
        'en':'Getting location data takes more time than usual. Please wait for the map to initialize',
        'de':'Den Standort abzurufen dauert länger, als üblich. Bitte warten, bis Karte gestartet wird.',
        'hu':'A térkép betöltése a szokásosnál több időt vesz igénybe. Kérjük várj.',
        'nl':'Getting location data takes more time than usual. Please wait for the map to initialize'
    },
    'Location found, you can join to the game.': {
        'en':'Location found, you can join to the game.',
        'de':'Standort gefunden. Spiel beitreten.',
        'hu':'Aktuális pozíció betöltve.',
        'nl':'Locatie gevonden, je kan het spel opstarten'
    },
    'Available interactive games': {
        'en':'Available interactive games',
        'de':'Verfügbare interaktive Spiele',
        'hu':'Elérhető játékok',
        'nl':'Available interactive games'
    },
    'Available games': {
        'en':'Available games',
        'de':'Verfügbare Spiele',
        'hu':'Elérhető játékok',
        'nl':'Available games'
    },
    'Switch language': {
        'en':'Change language',
        'de':'Sprache ändern',
        'hu':'Nyelv váltása',
        'nl':'Change language'
    },
    'Now we will redirect you to the payment page.': {
        'en':'Now we will redirect you to the payment page.',
        'de':'Die Weiterleitung zu Bezahlseite erfolgt nun.',
        'hu':"A tovább gomb lenyomásával továbbirányítunk a biztonságos Stripe fizetési oldalra. A bankkártyás fizetést követően a játékhoz szükséges információkat email formájában fogod megkapni.",
        'nl':'Now we will redirect you to the payment page.'
    },
    'Checkout': {
        'en':'Checkout',
        'de':'Zur Kasse',
        'hu':"Fizetés",
        'nl':'Checkout'
    },
    'Confirm': {
        'en':'Confirm',
        'de':'Bestätigung',
        'hu':"Rendben",
        'nl':'Checkout'
    },
    'Not supported browser': {
        'en':'Not supported browser',
        'de':'Nicht unterstützter Browser',
        'hu':"Nem támogatott böngésző",
        'nl':'Niet ondersteunde browser ' 
    },
    'The game only supports Chrome or Safari mobile browsers. ': {
        'en':'The game only supports Chrome or Safari mobile browsers. ',
        'de':'Das Spiel unterstützt nur CHROME und SAFARI Mobile Browser.',
        'hu':"A játék kizárólag Chrome vagy Safari böngészőkben játszható. ",
        'nl':'De game ondersteunt alleen mobiele Chrome- of Safari-browsers. ' 
    },
    'Double your points at the next question':{
        'en':'Double your points at the next question',
        'de':'Verdoppeln Sie Ihre Punkte bei der nächsten Frage',
        'hu':"A következő kérdés dupla vagy semmi ",
        'nl':'Verdubbel je punten op de volgende vraag' 
    },
    'You can freeze all players for 30 seconds':{
        'en':'You can freeze all players for 30 seconds',
        'de':'Sie können alle Spieler für 30 Sekunden einfrieren',
        'hu':"Lefagyaszthatod az összes játékost 30 másodpercre ",
        'nl':'Je kunt alle spelers 30 seconden bevriezen' 
        
    },
    'Be aware':{
        'en':'Be aware',
        'de':'Sei vorsichtig',
        'hu':"Figyelem",
        'nl':'Pas op' 
    }, 
    'Please note that the game only supports Chrome or Safari browsers. Do you want to proceed?':{
        'en':'Please note that the game only supports Chrome and Safari browsers. Do you want to proceed?',
        'de':'Bitte beachten Sie, dass das Spiel nur die Browser Chrome und Safari unterstützt. Willst du fortfahren?',
        'hu':"Felhívjuk a figyelmedet, hogy a játék csak a Chrome és a Safari böngészőket támogatja. Biztosan akarod folytatni?",
        'nl':'Houd er rekening mee dat de game alleen Chrome- en Safari-browsers ondersteunt. Wil je doorgaan?'   
    },
    'Yes':{
        'en':'Yes',
        'de':'Jawohl',
        'hu':"Igen",
        'nl':'Ja'   
    },
    'Felfedezős kalandjáték a mobilodon itt és most.':{
        'en':'Treasure hunt on your mobile! Here and now!',
        'de':'Schatzsuche auf Ihrem Handy! Hier und Jetzt!',
        'hu':"Felfedezős kalandjáték a mobilodon itt és most.",
        'nl':'Schattenjacht op je mobiel! Hier en nu!'   
    },
    'Játékok':{
        'en':'Games',
        'de':'Spiele',
        'hu':"Játékok",
        'nl':'Spellen'   
    },
    'A legteljesebb játékélményhez Chrome és Safari böngészők használata ajánlott.':{
        'en':'The game only supports Chrome or Safari mobile browsers. ',
        'de':'Das Spiel unterstützt nur CHROME und SAFARI Mobile Browser.',
        'hu':"A legteljesebb játékélményhez Chrome és Safari böngészők használata ajánlott. ",
        'nl':'De game ondersteunt alleen mobiele Chrome- of Safari-browsers. ' 
    },
    'Mire számítsak?': {
        'en':'What do I expect?',
        'de':'Was erwarte ich?',
        'hu':"Mire számítsak?",
        'nl':'Wat verwacht ik?'
    },
    'A játék': {
        'en':'The game',
        'de':'Das Spiel',
        'hu':"A játék",
        'nl':'Het spel'
    },
    'A játék során számos izgalmas kérdés és feladat által fedezed fel a helyszínt, és megismered titkait. A játék meglepetéseket is tartogat...': {
        'en':'During the game, you will explore the scene and learn its secrets through a number of exciting questions and tasks. The game also has surprises ...',
        'de':'Während des Spiels erkunden Sie die Szene und lernen ihre Geheimnisse durch eine Reihe spannender Fragen und Aufgaben kennen. Das Spiel hat auch Überraschungen ...',
        'hu':"A játék során számos izgalmas kérdés és feladat által fedezed fel a helyszínt, és ismered meg titkait. A játék meglepetéseket is tartogat...",
        'nl':'Tijdens het spel verken je de scène en leer je de geheimen ervan door middel van een aantal spannende vragen en taken. Het spel heeft ook verrassingen ...'
    },
    'Szerezz minél több pontot! Ehhez a térképen megjelölt helyszínekre kell eljutnod, ill. a kihelyezett QR kódokat beolvasnod.': {
        'en':'Get as many points as possible! To do this, you need to get to the locations marked on the map, or you can scan the posted QR codes.',
        'de':'Holen Sie sich so viele Punkte wie möglich! Dazu müssen Sie zu den auf der Karte markierten Orten gelangen oder Sie können die geposteten QR-Codes scannen.',
        'hu':"Szerezz minél több pontot! Ehhez a térképen megjelölt helyszínekre kell eljutnod, ill. a kihelyezett QR kódokat beolvasnod.",
        'nl':'Haal zoveel mogelijk punten! Om dit te doen, moet u naar de locaties die op de kaart zijn gemarkeerd, of u kunt de geposte QR-codes scannen.'
    },
    'Válaszd ki a játékot és kattints a "Játék indítása" gombra, amelyet követően a játék azonnal indul. Az első két feladvány ingyenes, amelyet után online bankkártyás fizetést követően folytathatod azt. Kalandra fel!': {
        'en':'Select the game and click on the "Start Game" button, after which the game will start immediately. The first two puzzles are free, and after that, you can continue by making an online payment with your credit card. Adventure awaits!',
        'de':'Wähle das Spiel aus und klicke auf die Schaltfläche "Spiel starten", danach beginnt das Spiel sofort. Die ersten beiden Rätsel sind kostenlos und danach kannst du sie durch eine Online-Zahlung mit deiner Kreditkarte fortsetzen. Abenteuer wartet!',
        'hu':'Válaszd ki a játékot és kattints a "Játék indítása" gombra, ezt követően a játék azonnal indul. Az első két feladvány ingyenes. Ezután online bankkártyás fizetéssel egyenlítsd ki a játék díját, hogy folytathasd. Kalandra fel!',
        'nl':'Kies het spel en klik op de knop "Start spel", waarna het spel direct begint. De eerste twee puzzels zijn gratis, en daarna kun je verdergaan door een online betaling met je creditcard te doen. Avontuur wacht!'
    },
    'Pontok': {
        'en':'Points',
        'de':'Punkte',
        'hu':'Pontok',
        'nl':'Punten'
    },
    'A játék indítása': {
        'en':'Start the game',
        'de':'Starte das Spiel',
        'hu':'A játék indítása',
        'nl':'Start het spel'
    },
    'Tovább a biztonságos fizetésre': {
        'en':'Secure payment',
        'de':'Sichern Sie weiterhin die Zahlung',
        'hu':'Tovább a biztonságos fizetésre',
        'nl':'Betaling te beveiligen'
    },
    'Lépj kapcsolatba velünk:': {
        'en':'Contact us:',
        'de':'Kontaktiere uns:',
        'hu':'Lépj kapcsolatba velünk:',
        'nl':'Neem contact met ons op:'
    },
    'Checking location data': {
        'en':'Checking location data',
        'de':'Überprüfung der Standortdaten',
        'hu':'Lokáció adatok frissítése',
        'nl':'Locatiegegevens controleren'
    },
    'Loading game': {
        'en':'Loading game',
        'de':'Spiel lädt',
        'hu':'Betöltés',
        'nl':'Spel laden'
    }, 
    'Congrats! You unlocked the last marker!': {
        'en':'Congrats! You unlocked the last marker!',
        'de':'Herzlichen Glückwunsch! Du hast die letzte Markierung freigeschaltet!',
        'hu':'Gratulálunk! Aktiváltad az utolsó pontot!',
        'nl':'Gefeliciteerd! Je hebt de laatste marker ontgrendeld!'
    },
    'Splashed egg': {
        'en':'Splashed egg',
        'de':'Gespritztes Ei',
        'hu':'Fröccsenő tojás',
        'nl':'Bespat ei'
    }, 
    'blank_map': {
        'en':'Splashed egg',
        'de':'Gespritztes Ei',
        'hu':'Fröccsenő tojás',
        'nl':'Bespat ei'
    }, 
    'A splashed egg is displayed to players, obscuring the map for 30 seconds.': {
        'en':'A splashed egg is displayed to players, obscuring the map for 30 seconds.',
        'de':'Ein bespritztes Ei wird den Spielern angezeigt und verdeckt die Karte für 30 Sekunden.',
        'hu':'Egy fröccsenő tojás jelenik meg a játékosok térképén, amely akadályozza a látásukat 30 másodpercig.',
        'nl':'Spelers krijgen een bespat ei te zien, waardoor de kaart 30 seconden wordt verduisterd.'
    }, 
    'Splashed egg perk is active for 30 seconds.': {
        'en':'Splashed egg perk is active for 30 seconds.',
        'de':'Der Perk „Bespritztes Ei“ ist 30 Sekunden lang aktiv.',
        'hu':'A fröccsenő tojás 30 másodpercig aktív.',
        'nl':'Spattend ei-voordeel is 30 seconden actief.'
    }, 'Flinkit is a new real world adventure game packed with codes to be cracked, clues to be uncovered, and puzzles to be solved in and outside. Fast, fun and easy to get going.': {
        'en':'Flinkit is a new real world adventure game packed with codes to be cracked, clues to be uncovered, and puzzles to be solved in and outside. Fast, fun and easy to get going.',
        'de':'RallyePlus Outdoor ist ein neuartiges Outdoorspiel, voller Abenteuer und kniffliger Aufgaben. Sie erhalten Punkte für jede gelöste Aufgabe. DAs Team mit den meisten Punkten gewinnt.',
        'hu':'A Flinkit egy a valós világban játszódó, mégis online kalandjáték, tele izgalmas fejtörőkkel, ahol nyomokat kell feltárni, és rejtvényeket kell megoldani. Gyors, szórakoztató és élménydús.',
        'nl':'Ludiris Outdoor! is een innovatief spel waarbij je zo secuur mogelijk een aantal vragen dient op te lossen op bepaalde locaties. Speel dit spel tegen elkaar in de stad. Snel, leuk en makkelijk te spelen.'
    }, 'Map tap': {
        'en':'Map tap',
        'de':'Kartenberührung',
        'hu':'Térkép érintés',
        'nl':'Kaart tik'
    }, 'Simulate your position by tapping on the map.': {
        'en':'Simulate your position by tapping on the map.',
        'de':'Simulieren Sie Ihre Position, indem Sie auf die Karte tippen.',
        'hu':'A térképen a megérintett pontra tudsz ugrani, így egy távoli pontot könnyen begyűjthetsz. A funkció 30 mp-ig él.',
        'nl':'Simuleer je positie door op de kaart te tikken.'
    },  'It allows you to simulate their position by tapping on the map, which allows you to reach remote points for up to 30 seconds.': {
        'en':'It allows you to simulate their position by tapping on the map, which allows you to reach remote points for up to 30 seconds.',
        'de':'Sie können Ihre Position simulieren, indem Sie auf die Karte tippen, was es Ihnen ermöglicht, entfernte Punkte für bis zu 30 Sekunden zu erreichen.',
        'hu':'A térképen a megérintett pontra tudsz ugrani, így egy távoli pontot könnyen begyűjthetsz. A funkció 30 mp-ig él.',
        'nl':'Hiermee kun je je positie simuleren door op de kaart te tikken, waardoor je op afgelegen punten tot 30 seconden kunt komen.'
    }, 'Take a photo': {
        'en':'Take a photo',
        'de':'Mach ein Foto',
        'hu':'Fotó készítése',
        'nl':'Maak een foto'
    },  'No image selected': {
        'en':'No image selected',
        'de':'Kein Bild ausgewählt',
        'hu':'Nincs kép kiválasztva',
        'nl':'Geen afbeelding geselecteerd'
    },  'Upload image': {
        'en':'Upload image',
        'de':'Bild hochladen',
        'hu':'Kép feltöltése',
        'nl':'Afbeelding uploaden'
    }, 
    "You've arrived to the last question": {
        'en':"You've arrived to the last question",
        'de':'Sie sind bei der letzten Frage angelangt',
        'hu':"Megérkeztél az utolsó kérdéshez!",
        'nl':'Je bent aangekomen bij de laatste vraag'
    },
    "You can unlock questions by approaching them. The points are triggered when you stand in a 10 meters radius.": {
        'en':"You can unlock questions by approaching them. The points are triggered when you stand in a 10 meters radius.",
        'de':'Sie können Fragen freischalten, indem Sie sich ihnen nähern. Die Punkte werden ausgelöst, wenn Sie in einem Umkreis von 10 Metern stehen.',
        'hu':"A pontok akkor aktiválódnak, ha 10 méteres körzetben állsz.",
        'nl':'U kunt vragen ontgrendelen door ze te benaderen. De punten worden geactiveerd wanneer u binnen een straal van 10 meter staat.'
    },
    "Please contact your game administrator": {
        'en':"Please contact your game administrator",
        'de':'Bitte wenden Sie sich an Ihren Spieladministrator',
        'hu':"Vedd fel a kapcsolatot a játék szervezőjével",
        'nl':'Neem contact op met je spelbeheerder'
    },
    "Refresh": {
        'en':"Refresh",
        'de':'Aktualisierung',
        'hu':"Frissítés",
        'nl':'Vernieuwen'
    },
    "In order to continue the game we redirect you to the checkout page. After the checkout you will be redirected to the game.": {
        'en':"To continue playing, the purchase of the game is necessary. We will redirect you to the payment interface for this purpose. After a successful payment, we will redirect you back to the game.",
        'de':'In order to continue the game we redirect you to the checkout page. After the checkout you will be redirected to the game.',
        'hu':"A játék folytatásához szükséges annak megvásárlása. Ehhez átirányítunk a fizetési felületre. A sikeres fizetés után pedig visszairányítunk a játékba.",
        'nl':'In order to continue the game we redirect you to the checkout page. After the checkout you will be redirected to the game.'
    },
    "Proceed to checkout": {
        'en':"Proceed to checkout",
        'de':'Proceed to checkout',
        'hu':"Tovább a fizetésre",
        'nl':'Proceed to checkout'
    },
    "Játék indítása": {
        'en':"Start game",
        'de':'Spiel starten',
        'hu':"Játék indítása",
        'nl':'Start spel'
    },
    "Uh oh": {
        'en':"Uh oh!",
        'de':'Uh oh!',
        'hu':"Ajjaj!",
        'nl':'Uh oh!'
    },
    "Your email address": {
        'en':"Your email address",
        'de':'Your email address',
        'hu':"Email címed",
        'nl':'Your email address'
    },
    "Enter your email address": {
        'en':"Enter your email address!",
        'de':'Enter your email address',
        'hu':"Kérjük add meg az email címedet",
        'nl':'Enter your email address'
    }
   


    
    

    
  }
  
    let newTranslations = [
        {
            "_key": "Hall of fame",
            "fr": "Palmarès"
        },
        {
            "_key": "Maximum number of players reached",
            "fr": "Nombre de joueurs maximum atteint"
        },
        {
            "_key": "Image successfully uploaded",
            "fr": "Image téléchargée avec succès"
        },
        {
            "_key": "You can throw a bomb on a random player.",
            "fr": "Vous pouvez lancer une bombe sur un joueur au hasard."
        },
        {
            "_key": "You just activated the bomb perk.",
            "fr": "Vous venez d'activer l'effet bombe."
        },
        {
            "_key": "Bomb perk active. Half points at next question.",
            "fr": "Effet bombe activé. Moitié des points à la prochaine question."
        },
        {
            "_key": "No other players to use this perk on.",
            "fr": "Pas d'autre joueur sur lequel cet effet peut être utilisé."
        },
        {
            "_key": "Freeze",
            "fr": "Geler"
        },
        {
            "_key": "Free",
            "fr": "Gratuit"
        },
        {
            "_key": "Bomb",
            "fr": "Bombe"
        },
        {
            "_key": "Blank map",
            "fr": "Carte vide"
        },
        {
            "_key": "Photo gallery",
            "fr": "Photos"
        },
        {
            "_key": "freeze",
            "fr": "Geler"
        },
        {
            "_key": "bomb",
            "fr": "Bombe"
        },
        {
            "_key": "photo",
            "fr": "Photos"
        },
        {
            "_key": "map_tap",
            "fr": "Toucher la carte"
        },
        {
            "_key": "Freeze perk will freeze all other players for 30 seconds.",
            "fr": "L'effet Congel' fige 30 secondes tous les autres joueurs."
        },
        {
            "_key": "You can take photos during the game.",
            "fr": "Vous pouvez prendre des photos pendant le jeu."
        },
        {
            "_key": "You just activated the photo perk.",
            "fr": "Vous venez d'activer l'effet photo."
        },
        {
            "_key": "Blank map perk is active for 30 seconds.",
            "fr": "Effet carte vide activé 30 secondes"
        },
        {
            "_key": "It will change the map style to a blank map for other players for 30 seconds.",
            "fr": "La carte apparaitra vide 30 secondes pour les autres joueurs."
        },
        {
            "_key": "PIN to join the game: ",
            "fr": "PIN pour se connecter au jeu : "
        },
        {
            "_key": "Position updated!",
            "fr": "Position mise à jour !"
        },
        {
            "_key": "What is the goal of the game?",
            "fr": "Quel est le but du jeu ?"
        },
        {
            "_key": "To collect all the story points",
            "fr": "Trouvez tous les marqueurs et gagnez plein de points !"
        },
        {
            "_key": "To wait until the time is up",
            "fr": "Attendre la fin du jeu"
        },
        {
            "_key": "To stay outside the battle circle",
            "fr": "Rester en dehors du cercle"
        },
        {
            "_key": "Don't forget to use the 'Refresh my position' button regularly to refresh your current location in the game.",
            "fr": "N'oubliez pas d'utiliser régulièrement le bouton Actualiser ma position pour rafraîchir votre position !"
        },
        {
            "_key": "Hurry up, only ",
            "fr": "Vite, il reste "
        },
        {
            "_key": " minutes left!",
            "fr": "minutes !"
        },
        {
            "_key": "Got it",
            "fr": "Compris !"
        },
        {
            "_key": "Backpack item",
            "fr": "Objet du sac à dos"
        },
        {
            "_key": "This item may help you to solve the final riddle.",
            "fr": "Cet objet peut vous aider à résoudre l'énigme finale."
        },
        {
            "_key": "Back",
            "fr": "Retour"
        },
        {
            "_key": "Next",
            "fr": "Suivant"
        },
        {
            "_key": "Congrats! You've activated the safehouse! Now find it on the map and reach it before it's too late!",
            "fr": "Félicitations, vous avez activé la Safehouse ! Trouvez-la sur la carte et allez-y avant qu'il ne soit trop tard !"
        },
        {
            "_key": " is a fellow player in the musesum who scored ",
            "fr": "est un autre joueur dans le musée qui a obtenu"
        },
        {
            "_key": " points so far.",
            "fr": "points jusqu'ici"
        },
        {
            "_key": " The player is still in the museum!",
            "fr": "Le joueur est encore dans le musée !"
        },
        {
            "_key": "You don't have enough points to use this perk.",
            "fr": "Vous n'avez pas assez de points pour utiliser cet effet."
        },
        {
            "_key": "Use perk",
            "fr": "Utiliser un effet"
        },
        {
            "_key": "Double perk is active. You will receive doupled points at the next question if your answer is correct.",
            "fr": "Effet-Double est activé. Vous doublez des points à la prochaine question si votre réponse est correcte."
        },
        {
            "_key": "Freeze perk is active. You frozed all other players for 30 seconds.",
            "fr": "Effet Congel' est activé. Vous avec figé tous les autres joueurs pendant 30 secondes."
        },
        {
            "_key": "Do you really want to end the game?",
            "fr": "Vous voulez vraiment quitter le jeu ?"
        },
        {
            "_key": "You cannot rejoin in the game if you hit 'End Game'",
            "fr": "Vous ne pourrez plus rejoindre le jeu si vous cliquez sur Terminer le jeu"
        },
        {
            "_key": "End Game",
            "fr": "Terminer le jeu"
        },
        {
            "_key": "This QR code has been activated already",
            "fr": "Ce code QR a déjá été activé. "
        },
        {
            "_key": "Do you really want to launch the game?",
            "fr": "Vous voulez vraiment lancer le jeu ?"
        },
        {
            "_key": 'The game will start for every other players by clicking "Start game"',
            "fr": "Le jeu commencera pour tous les autres joueurs en cliquant sur Commencer le jeu"
        },
        {
            "_key": "PIN error",
            "fr": "PIN erroné"
        },
        {
            "_key": "This PIN has expired",
            "fr": "Ce PIN a expiré"
        },
        {
            "_key": "Wrong PIN",
            "fr": "Mauvais PIN"
        },
        {
            "_key": "There is no game with this PIN",
            "fr": "Il n'y a pas de jeu lié à ce PIN"
        },
        {
            "_key": "Cannot access location",
            "fr": "Impossible d'accéder à la localisation"
        },
        {
            "_key": "You need to grant access to the browser to start the game.",
            "fr": "Vous devez autoriser l'accès au navigateur pour démarrer le jeu."
        },
        {
            "_key": "You are standing outside the battle circle. You've lost ",
            "fr": "Vous êtes en dehors du cercle. Vous avez perdu"
        },
        {
            "_key": " points!",
            "fr": "points !"
        },
        {
            "_key": "Well, there are no markers nearby.",
            "fr": "Pas de marqueurs dans les environs."
        },
        {
            "_key": "Correct answer",
            "fr": "Bonne réponse "
        },
        {
            "_key": "Correct answer! You have earned ",
            "fr": "Bonne réponse! Vous avez obtenu"
        },
        {
            "_key": "The correct answer would be: ",
            "fr": "La bonne réponse serait : "
        },
        {
            "_key": "The time is up",
            "fr": "Le temps est terminé."
        },
        {
            "_key": "A new item has been added to your backpack!",
            "fr": "Un nouvel objet a été placé dans votre sac à dos !"
        },
        {
            "_key": "Incorrect answer",
            "fr": "Mauvaise réponse"
        },
        {
            "_key": "Try again",
            "fr": "Réessayez"
        },
        {
            "_key": "Start game",
            "fr": "Commencer le jeu"
        },
        {
            "_key": "Getting location data takes more time than usual. Please wait for the map to initialize",
            "fr": "Le téléchargement des données de localisation prend du temps. Merci de patienter."
        },
        {
            "_key": "Location found, you can join to the game.",
            "fr": "Emplacement trouvé, vous pouvez commencer le jeu."
        },
        {
            "_key": "Available interactive games",
            "fr": "Jeux interactifs disponibles"
        },
        {
            "_key": "Available games",
            "fr": "Jeux disponibles"
        },
        {
            "_key": "Switch language",
            "fr": "Changer la langue"
        },
        {
            "_key": "Now we will redirect you to the payment page.",
            "fr": "Vous allez être redirigé vers la page de paiement."
        },
        {
            "_key": "Checkout",
            "fr": "Passer à la caisse"
        },
        {
            "_key": "Confirm",
            "fr": "Confirmer"
        },
        {
            "_key": "Not supported browser",
            "fr": "Navigateur non compatible"
        },
        {
            "_key": "The game only supports Chrome or Safari mobile browsers. ",
            "fr": "Le jeu est compatible uniquement avec Chrome ou Safari."
        },
        {
            "_key": "Double your points at the next question",
            "fr": "Doublez vos points à la prochaine question"
        },
        {
            "_key": "You can freeze all players for 30 seconds",
            "fr": "Vous pouvez geler les autres joueurs pendant 30 secondes"
        },
        {
            "_key": "Be aware",
            "fr": "Attention"
        },
        {
            "_key": "Please note that the game only supports Chrome or Safari browsers. Do you want to proceed?",
            "fr": "Veuillez noter que le jeu est compatible uniquement avec Chrome ou Safari. Vous voulez continuer ? "
        },
        {
            "_key": "Yes",
            "fr": "Oui"
        },
        {
            "_key": "Felfedezős kalandjáték a mobilodon itt és most.",
            "fr": "Une chasse au trésors sur votre smartphone ? C'est par ici !"
        },
        {
            "_key": "Játékok",
            "fr": "Jeux"
        },
        {
            "_key": "A legteljesebb játékélményhez Chrome és Safari böngészők használata ajánlott.",
            "fr": "Le jeu est compatible uniquement avec Chrome ou Safari."
        },
        {
            "_key": "Mire számítsak?",
            "fr": "Qu'est-ce qui m'attend ?"
        },
        {
            "_key": "A játék",
            "fr": "Le jeu"
        },
        {
            "_key": "A játék során számos izgalmas kérdés és feladat által fedezed fel a helyszínt, és megismered titkait. A játék meglepetéseket is tartogat...",
            "fr": "Au cours du jeu, vous explorerez le terrain et découvrirez ses secrets à travers des questions et des énigmes passionnantes. Plein de surprises vous attendent !"
        },
        {
            "_key": "Szerezz minél több pontot! Ehhez a térképen megjelölt helyszínekre kell eljutnod, ill. a kihelyezett QR kódokat beolvasnod.",
            "fr": "Obtenez le plus de points possible ! Pour ça, vous devez vous rendre aux endroits indiqués sur la carte, ou vous pouvez scanner les codes QR affichés."
        },
     
        {
            "_key": "Pontok",
            "fr": "Points"
        },
        {
            "_key": "A játék indítása",
            "fr": "Commencer le jeu"
        },
        {
            "_key": "Tovább a biztonságos fizetésre",
            "fr": "Paiement sécurisé"
        },
        {
            "_key": "Lépj kapcsolatba velünk:",
            "fr": "Contact : "
        },
        {
            "_key": "Checking location data",
            "fr": "Vérification des données de localisation"
        },
        {
            "_key": "Loading game",
            "fr": "Chargement du jeu"
        },
        {
            "_key": "Congrats! You unlocked the last marker!",
            "fr": "Félicitations, vous avez débloqué la dernIère énigme !"
        },
        {
            "_key": "Splashed egg",
            "fr": "oeuf éclaté"
        },
        {
            "_key": "blank_map",
            "fr": "oeuf éclaté"
        },
        {
            "_key": "A splashed egg is displayed to players, obscuring the map for 30 seconds.",
            "fr": "Un oeuf éclaté apparaît aux joueurs, masquant la carte pendant 30 secondes."
        },
        {
            "_key": "Splashed egg perk is active for 30 seconds.",
            "fr": "Effet oeuf éclaté activé pendant 30 secondes."
        },
        {
            "_key": "Flinkit is a new real world adventure game packed with codes to be cracked, clues to be uncovered, and puzzles to be solved in and outside. Fast, fun and easy to get going.",
            "fr": "Flinkit Rallye Outdoor est un nouveau jeu d'aventures à l'extérieur où vous devez déchiffrer des codes, découvrir des indices et résoudre des énigmes. Chaque énigme résolue rapporte des points. L'équipe avec le maximum de points remporte la victoire. "
        },
        {
            "_key": "Map tap",
            "fr": "Toucher la carte"
        },
        {
            "_key": "Simulate your position by tapping on the map.",
            "fr": "Simulez votre position en tapant sur la carte."
        },
        {
            "_key": "It allows you to simulate their position by tapping on the map, which allows you to reach remote points for up to 30 seconds.",
            "fr": "Vous pouvez simuler votre position en tapant sur la carte, ce qui vous permet d'atteindre des endroits éloignés pendant 30 secondes."
        },
        {
            "_key": "Take a photo",
            "fr": "Prendre une photo"
        },
        {
            "_key": "No image selected",
            "fr": "Aucune image sélectionnée"
        },
        {
            "_key": "Upload image",
            "fr": "Télécharger l'image"
        },
        {
            "_key": "You've arrived to the last question",
            "fr": "Vous êtes arrivé à la dernière question !"
        },
        {
            "_key": "You can unlock questions by approaching them. The points are triggered when you stand in a 10 meters radius.",
            "fr": "Vous débloquez des questions en vous en rapprochant. Les points sont activés lorsque vous vous trouvez dans un rayon de 10 mètres."
        },
        {
            "_key": "Please contact your game administrator",
            "fr": "Veuillez contacter votre responsable de jeu"
        },
        {
            "_key": "Refresh",
            "fr": "Rafraîchir"
        }
    ]

newTranslations.forEach((val, i) => {
console.log(i, val)
	translations[val._key].fr = val.fr
}); 

console.log(JSON.stringify(translations))
} */
